var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forward-editor-main"},[_c('div',{staticClass:"forward-info"},[_vm._v("\n    转发："+_vm._s(_vm.forwardInfo)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"editor-wrapper"},[_c('LiveEditor',{ref:"liveEditor",attrs:{"disabled":_vm.disabled,"enablePictureUpload":false,"enableVideoUpload":false},on:{"submit":_vm.submitLive}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00cedb6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/ForwardEditor.vue
// module id = null
// module chunks = 